import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

interface LayoutProps {
  children: React.ReactNode;
}

function scrollTo(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

const WA = 'https://chat.whatsapp.com/DeAfc79sKr2AdppE1xJafE';
const LOGO = 'https://static-us-img.skywork.ai/prod/user/head_picture/2048929072999747584_logo horizontal negativo.png';

export function Layout({ children }: LayoutProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const fn = () => setIsScrolled(window.scrollY > 30);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const links = [
    { id: 'formato', label: 'Formato' },
    { id: 'network', label: 'Network' },
    { id: 'fit',     label: 'Para Quem É' },
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#081A2D' }}>
      <header
        className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
        style={{
          background:    isScrolled ? 'rgba(8,26,45,0.97)' : 'transparent',
          borderBottom:  isScrolled ? '1px solid rgba(120,176,227,0.10)' : '1px solid transparent',
          backdropFilter: isScrolled ? 'blur(12px)' : 'none',
        }}
      >
        <nav className="max-w-6xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-[72px]">

            {/* Logo */}
            <button onClick={() => scrollTo('hero')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
              <img src={LOGO} alt="ClinoGrow" style={{ height: 28, width: 'auto', objectFit: 'contain', display: 'block' }} />
            </button>

            {/* Desktop links */}
            <div className="hidden md:flex items-center gap-8">
              {links.map(l => (
                <button key={l.id} onClick={() => scrollTo(l.id)}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 500, color: '#78B0E3', transition: 'color 0.2s' }}
                  onMouseEnter={e => (e.currentTarget.style.color = '#FFFFFF')}
                  onMouseLeave={e => (e.currentTarget.style.color = '#78B0E3')}
                >
                  {l.label}
                </button>
              ))}
              <a href={WA} target="_blank" rel="noopener noreferrer"
                style={{ display: 'inline-flex', alignItems: 'center', padding: '10px 22px', borderRadius: 6, backgroundColor: '#F4A35B', color: '#081A2D', fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 700, textDecoration: 'none', transition: 'background 0.2s' }}
                onMouseEnter={e => ((e.currentTarget as HTMLElement).style.backgroundColor = '#f8b878')}
                onMouseLeave={e => ((e.currentTarget as HTMLElement).style.backgroundColor = '#F4A35B')}
              >
                Quero uma vaga
              </a>
            </div>

            {/* Mobile toggle */}
            <button className="md:hidden" onClick={() => setMenuOpen(!menuOpen)}
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#FFFFFF' }}>
              {menuOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>

          {menuOpen && (
            <div className="md:hidden py-5" style={{ borderTop: '1px solid rgba(120,176,227,0.10)' }}>
              <div className="flex flex-col gap-4">
                {links.map(l => (
                  <button key={l.id} onClick={() => { scrollTo(l.id); setMenuOpen(false); }}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 500, color: '#78B0E3' }}>
                    {l.label}
                  </button>
                ))}
                <a href={WA} target="_blank" rel="noopener noreferrer"
                  style={{ textAlign: 'center', padding: '12px 24px', borderRadius: 6, backgroundColor: '#F4A35B', color: '#081A2D', fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 700, textDecoration: 'none' }}>
                  Quero uma vaga
                </a>
              </div>
            </div>
          )}
        </nav>
      </header>

      <main>{children}</main>

      <footer style={{ backgroundColor: '#060F1A', borderTop: '1px solid rgba(120,176,227,0.08)' }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-12 py-10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-5">
            <button onClick={() => scrollTo('hero')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
              <img src={LOGO} alt="ClinoGrow" style={{ height: 22, opacity: 0.7, objectFit: 'contain', display: 'block' }} />
            </button>
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 16, fontFamily: "'DM Sans',sans-serif", fontSize: 13, color: 'rgba(120,176,227,0.5)' }}>
              <span>© 2026 ClinoGrow. Todos os direitos reservados.</span>
              <a href="https://clinogrow.com.br" target="_blank" rel="noopener noreferrer"
                style={{ color: '#78B0E3', textDecoration: 'none' }}
                onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = '#F4A35B')}
                onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = '#78B0E3')}>
                clinogrow.com.br
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
